/** HTTP ステータス */
export const HTTP_STATUS = {
  // OK
  OK: 200,
  // リソース作成
  CREATED: 201,
  // 不正なリクエスト
  BAD_REQUEST: 400,
  // 認証が必要である
  UNAUTHORIZED: 401,
  // 決済情報が必要・課金上限を超えてしまった場合
  PAYMENT_REQUIRED: 402,
  // リソースへのアクセス権限・認証はOK
  FORBIDDEN: 403,
  // リソースが存在しない
  NOT_FOUND: 404,
  // 更新のバッティングやユニークなIDの重複
  CONFLICT: 409,
  // サービス利用不可
  LEGAL_REASONS: 451,
  // サーバー側のエラー
  INTERNAL_SERVER_ERROR: 500,
  // サービス利用不可
  SERVICE_UNAVAILABLE: 503,
};

/** HTTP ステータスメッセージ */
export const HTTP_STATUS_MESSAGE = {
  DEFAULT: '通信に失敗しました。接続を確認してください',
  FORBIDDEN: '権限がありません',
  NOT_FOUND: '既に削除されています',
  LEGAL_REASONS: '現在の環境からはアクセス出来ません。許可された環境より再度お試し下さい',
};
